var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 4C4.71634 4 4 4.71634 4 5.6V9.86667C4 10.7503 4.71634 11.4667 5.6 11.4667H9.86667C10.7503 11.4667 11.4667 10.7503 11.4667 9.86667V5.6C11.4667 4.71634 10.7503 4 9.86667 4H5.6Z",
    fill: "#363978"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1333 4C13.2497 4 12.5333 4.71634 12.5333 5.6V9.86667C12.5333 10.7503 13.2497 11.4667 14.1333 11.4667H18.4C19.2837 11.4667 20 10.7503 20 9.86667V5.6C20 4.71634 19.2837 4 18.4 4H14.1333Z",
    fill: "#363978"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 12.5333C4.71634 12.5333 4 13.2497 4 14.1333V18.4C4 19.2837 4.71634 20 5.6 20H9.86667C10.7503 20 11.4667 19.2837 11.4667 18.4V14.1333C11.4667 13.2497 10.7503 12.5333 9.86667 12.5333H5.6Z",
    fill: "#363978"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1333 12.5333C13.2497 12.5333 12.5333 13.2497 12.5333 14.1333V18.4C12.5333 19.2837 13.2497 20 14.1333 20H18.4C19.2837 20 20 19.2837 20 18.4V14.1333C20 13.2497 19.2837 12.5333 18.4 12.5333H14.1333Z",
    fill: "#363978"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/DashboardIcon.7d284c2743fcc36fa8e3f444176fa0af.svg";
export { ForwardRef as ReactComponent };